import type {
  AssignmentLine,
  CartAssignment,
} from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';

type ShipToLine = Pick<
  AssignmentLine,
  'shipToWarehouseId' | 'destinationWarehouseId' | 'topOption'
>;

/**
 * Name of the PO ship-to for a line, but only when a vendor actually ships
 * somewhere other than the destination warehouse. That happens on a pivot
 * (buy_and_transfer): the vendor ships to an upstream hub and a transfer
 * carries the stock on to the branch. A direct buy ships to the destination,
 * and a pure transfer has no vendor delivery at all (the supplier board keys
 * its cart by the transfer source), so both return null and the Warehouse
 * column shows the destination alone.
 */
export function getDivergentShipToName(
  line: ShipToLine,
  cartsByShipTo: Map<string, CartAssignment> | undefined,
): string | null {
  const shipToWarehouseId = getDivergentShipToId(line);
  if (shipToWarehouseId === null) return null;
  return cartsByShipTo?.get(shipToWarehouseId)?.shipToWarehouseName ?? null;
}

/** The id behind {@link getDivergentShipToName}. */
export function getDivergentShipToId(line: ShipToLine): string | null {
  const action = line.topOption?.action;
  if (action !== 'buy' && action !== 'buy_and_transfer') return null;
  const { shipToWarehouseId, destinationWarehouseId } = line;
  if (!shipToWarehouseId || shipToWarehouseId === destinationWarehouseId) {
    return null;
  }
  return shipToWarehouseId;
}
